export default function LoadingScreen({ doorState }) {
    const getDoorClass = (isLeft) => {
        if (doorState === "closed") {
            // Doors slide to closed position
            return "translate-x-0";
        } else if (doorState === "open") {
            // Doors slide to open position
            return isLeft ? "-translate-x-full" : "translate-x-full";
        } else {
            // Initial state: doors open
            return isLeft ? "-translate-x-full" : "translate-x-full";
        }
    };
  
    return (
        <div className="fixed inset-0 z-50 bg-transparent flex items-center justify-center">
            {/* Left door */}
            <div 
                className={`absolute inset-y-0 left-0 w-1/2 bg-slate-900 transition-transform duration-700 ease-in-out ${getDoorClass(true)}`}
                style={{ backgroundImage: "url('/assets/doors/left-door.png')", backgroundSize: "cover" }}
            />
            {/* Right door */}
            <div 
                className={`absolute inset-y-0 right-0 w-1/2 bg-slate-900 transition-transform duration-700 ease-in-out ${getDoorClass(false)}`}
                style={{ backgroundImage: "url('/assets/doors/right-door.png')", backgroundSize: "cover" }}
            />
            {/* Center content */}
            
        </div>
    );
}